import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { QuotaInfo } from '../services/myDriveService';

interface Props {
  quota: QuotaInfo | null;
}

export default function QuotaBar({ quota }: Props) {
  if (!quota) return null;

  const color = quota.used_pct >= 100 ? 'error' : quota.used_pct >= 90 ? 'warning' : 'primary';

  return (
    <Box sx={{ minWidth: 200 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="caption">
          {quota.used_gb.toFixed(2)} / {quota.quota_gb.toFixed(1)} GB
        </Typography>
        <Typography variant="caption" color={color + '.main'}>
          {quota.used_pct.toFixed(1)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={Math.min(quota.used_pct, 100)}
        color={color}
        sx={{ height: 6, borderRadius: 3 }}
      />
    </Box>
  );
}
